import type { FaireProductEntity } from "../../entity_types/product";

export const p_5nqe9sf3py: FaireProductEntity = {
  token: "p_5nqe9sf3py",
  type: "product",
  name: "Abstract Face Candles",
  brandToken: "b_wwmw5suxv7",
  brandName: "Molly Moon Crafts",
  imageUrl:
    "https://cdn.faire.com/fastly/8cac5fb6ef821ec8008fd71b74698b20c5862be8f5fd1d600ae8b1b526ce5d4e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d7cba7706a819c6bae3b9fd5266d0824405574443f2f66e9d4713de93bc1e11.jpeg",
    "https://cdn.faire.com/fastly/46bbd09899a9689ad47728b8f49d990af0a05f4ebef5464ffd924320e9c211f0.jpeg",
    "https://cdn.faire.com/fastly/614c64d4bf92dffdf601e4112f81387d0a1166f8a695e337090d37861d168619.jpeg",
    "https://cdn.faire.com/fastly/fae4ec61caf6dbc3439b1de5159720c2b86fcb01d9215dfc1a1159afe1994a3a.jpeg",
    "https://cdn.faire.com/fastly/2d5b65e54250c90666cfb475e5db9e63af5e674de01f9f61427b358f27fe743f.png",
  ],
  priceDollars: 13,
  description:
    'Handmade Abstract Face Candles! Made with soy wax, lightly scented with clean fragrance, and cotton wick. \n\nEach candle is made to order and may have small variations or natural wax crystallization.\n\nHow to use: Place your candle on a heat resistant surface and trim wick down to about 1/2 inch before lighting. Please always burn within eyesight & keep out of reach of children.\n\nMeasurements:\nLong Face - 2" x 3.75"\n2 Face - 2.5"x 3.75"\nSquare Face - 3.5" x 3.5"\nRound Face - 3.25" x 2.75"\n\nWith every sale we donate to the Mojave Desert Land Trust! (MDLT) is a 501(c)(3) nonprofit taking on the greatest challenges facing the California desert, permanently protecting land, restoring habitat, and preserving native seeds. The vision of MDLT for the California desert includes dark night skies, clean air and water, broad views and vistas, and an abundance of native plants and animals.',
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:21.631Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
